<div *ngIf="!themeService.loading" class="full-size">
  <mat-sidenav-container class="full-size">

    <mat-sidenav class="padding-safe-top padding-safe-left" id="sidenavList" #sidenavList [mode]="layoutService.singleView? 'over' : 'side'" opened position="start" [class]="layoutService.singleView? 'full-width' : 'partial-width'">

      <div class="status-bar-colored-left"></div>
      <div class="status-bar-colored-bottom"></div>

      <app-hymn-finder></app-hymn-finder>
    </mat-sidenav>

    <mat-sidenav-content class="padding-safe-top" #scroll id="scrollable_container">
      <div class="sticky-statusbar"></div>
      <div class="container" id="main-content">
        <router-outlet></router-outlet>
      </div>
    </mat-sidenav-content>

    <mat-sidenav class="padding-safe-top padding-safe-right" #sidenavSettings id="sidenavSettings" [mode]="layoutService.singleView? 'over' : 'side'" position="end" [class]="layoutService.singleView? 'full-width' : 'partial-width'">

      <div class="status-bar-colored-right"></div>

      <div class="sticky-statusbar"></div>
      <app-settings-manager></app-settings-manager>
    </mat-sidenav>
  </mat-sidenav-container>

  <app-debugger *ngIf="settingService.debuggerConsole"></app-debugger>

</div>
